module.exports = {
    siteUrl: `https://newsliner-gatsby.epilocal.com`, // Site domain. Do not include a trailing slash!

    postsPerPage: 6, // Number of posts shown on paginated pages (changes this requires sometimes to delete the cache)

    siteTitleMeta: `Newsliner for Gatsby`, // This allows an alternative site title for meta data for pages.
    siteDescriptionMeta: `A starter template to build static websites with Ghost and Gatsby using the Newsliner theme by Epilocal`, // This allows an alternative site description for meta data for pages.

    shareImageWidth: 1000, // Change to the width of your default share image
    shareImageHeight: 523, // Change to the height of your default share image

    shortTitle: `Newsliner-Gatsby`, // Used for App manifest e.g. Mobile Home Screen
    siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
    backgroundColor: `#e9e9e9`, // Used for Offline Manifest
    themeColor: `#47698e`, // Used for Offline Manifest
}
